export default {
    common:{
        searchPlaceHolder:'Please Enter Keywords',
        buttonText:'Search',
        contactText:'Contact Us',
        swichLang:'Chinese',
        plsaseChoose:'plsaseChoose',
        product:'product',
        news:'news'
    },
    home:{
        nodata:'there is no data',
        more:'more',
        detail:'detail',
        news:'news',
        responsibility:'responsibility',
        products:'products'
    },
    about:'about',
    nowAddress:'current location',
    noData:'noData',
    products:{
        title:'products',
        brand:'anbang',
        matName:'matName',
        generalName:'generalName',
        checkDetail:'checkDetail'
    },
    responsibility:'responsibility',
    culture:{
        title:'culture',
        checkDetail:'checkDetail',
        download:'download'
    },
    rd:'research and development centre',
    member:'member'
}